// AUTO-GENERATED by scripts/gen-build-info.js — do not edit
const buildInfo = {
    version: "1.0.204781",
    builtAt: "2026-05-23T05:01:27.668Z",
};
export default buildInfo;
